module.exports = __webpack_public_path__ + "static/img/user_bg.7eee56f0.png";